export default __webpack_public_path__ + "static/krispcallLogo-72ff8cd2c37a87ae1a5bbdbc735d2fc1.png";